/* eslint-disable */
// The whole code is copied from VPC.

import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { DateTimeText } from './DateTimeCells';
import { AppUrls } from '../../../../app/AppUrls';
import { ExtractEncryptionMode } from '../../../models/SitePropertyTypes';
import { DataSource } from '../../../models/SearchResultTypes';
import { ExtractEncryptionState } from '../../../models/DataSourceInfo';
import { Messages } from '../../../../../gen-src/Localize';
import { GetDataConnectionChannel } from '@tableau/search-microview-communication-channels';
import { ActivitySpinnerSize, ActivitySpinnerWidget, TabStyles } from '@tableau/widgets';
import { cssClass } from '../../../../common/styles/CommonStyles';

// The linter is flagging a potentially interesting problem (this code existed before we enabled
// this lint rule). Disabling the lint rule for now, tracking the problem in TFS 1257623.

export const ExtractStatusSpinner = cssClass('extractStatusSpinner', {
  display: 'inline-block',
  verticalAlign: 'sub',
  marginLeft: TabStyles.Spacing.DefaultSpace,
  marginRight: TabStyles.Spacing.DefaultSpace,
});

export function LastRefreshedCell(
  siteUrl: AppUrls,
  isExtractEncryptionEnabled: boolean,
  siteEaRMode: ExtractEncryptionMode,
  isWorkbookPlace?: boolean
): React.Factory<BodyCell.Props> {
  return StyledCellFormatter(function LastRefreshedCell(props: BodyCell.Props | undefined) {
    const datasource = props!.row.data as DataSource;
    const psExtracts = datasource.publishedDatasourceDetails ? datasource.publishedDatasourceDetails.hasExtracts : false;
    const esExtracts = datasource.hasExtracts;
    const isExtract = esExtracts || psExtracts;
    // const spaceUrls = siteUrl;

    const labelStyle: React.CSSProperties = {
      marginRight: 18,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };

    const [contentText, setContentText] = React.useState('');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // const [federatedConnections, setFederatedConnections] = React.useState(0);

    React.useEffect(() => {
      let federatedFile = 0;
      let federatedDatabase = 0;
      let multipleConnections: string;

      const dateTimeOptions = { ...props!, propertyName: 'dataFreshness' };
      const lastRefreshedCell = true;
      const total_Connections = datasource.dataConnectionsCount;
      const dateTime = DateTimeText(dateTimeOptions);
      const delimiter = isExtract && dateTime ? String.fromCharCode(8212) : String.fromCharCode(8195);
      const extractStatus = getDatasourceStatus(
        isExtractEncryptionEnabled,
        datasource.connectionType || '',
        datasource.isFileBased || false,
        isExtract,
        datasource.extractEncryptionState || null,
        datasource.extractCreationPending || false,
        siteEaRMode,
        lastRefreshedCell
      );

      if (total_Connections === 1) {
        // setFederatedConnections(0);
        setContentText(`${extractStatus}${delimiter}${dateTime}`);
        return;
      }

      if (total_Connections && total_Connections > 1) {
        const getDataConnectionChannel = new GetDataConnectionChannel();
        getDataConnectionChannel.call({ dataSourceIds: [datasource.id] }).data?.then((conn) => {
          // setFederatedConnections(conn.length - 1);
          for (let i = 0; i < conn.length; i++) {
            if (conn[i].type === 'file') {
              federatedFile = federatedFile + 1;
            } else {
              federatedDatabase = federatedDatabase + 1;
            }
          }
          if (federatedFile > 0 && federatedDatabase > 0) {
            multipleConnections = Messages.federatedFileBased({ COUNT: federatedFile }) + ',' + Messages.liveConnection();
          } else if (federatedDatabase === 0) {
            multipleConnections = Messages.federatedFileBased({ COUNT: federatedFile });
          } else {
            multipleConnections = Messages.liveConnection();
          }

          setContentText(`${multipleConnections}${delimiter}${dateTime}`);
        });
      }
    }, []);
    const shouldShowSpinner =
      (datasource.extractEncryptionState === ExtractEncryptionState.pendingDecryption ||
        datasource.extractEncryptionState === ExtractEncryptionState.pendingEncryption ||
        (!isExtract && datasource.extractCreationPending));
    return (
      <div style={labelStyle}>
        {shouldShowSpinner ? (
          <span key={1} className={ExtractStatusSpinner}>
            <ActivitySpinnerWidget testId="extract-status" spinnerSize={ActivitySpinnerSize.Small} />
          </span>
        ) : null}
        {/* {datasource.connectionDetails && (
          <TooltipAnchor
            tooltipContent={() => (
              <StatusToolTip
                content={(props ? props.row.data : null) as DataSource}
                urls={spaceUrls}
                federatedCount={federatedConnections}
                isWorkbookPlace={isWorkbookPlace}
              />
            )}
            disableAutoFocus={true}
            title={Messages.datasourceDetails()}
            disableTooltip={false}
          >
            {contentText}
          </TooltipAnchor>
        )}
        {!datasource.connectionDetails && <>{contentText}</>} */}
        {contentText}
      </div>
    );
  });
}

function getDatasourceStatus(
  isExtractEncryptionEnabled: boolean,
  connectionType: string,
  isFileBased: boolean,
  hasExtracts: boolean,
  extractEncryptionState: ExtractEncryptionState | null,
  extractCreationPending: boolean,
  siteEaRMode: ExtractEncryptionMode,
  lastRefreshedCell?: boolean
): string {
  const messages = new Map<ExtractEncryptionState, string>([
    [ExtractEncryptionState.encrypted, Messages.ear_Extract_Encryption_State_Encrypted()],
    [
      ExtractEncryptionState.pendingDecryption,
      Messages.ear_Extract_Encryption_State_Decrypting_mttw(),
    ],
    [
      ExtractEncryptionState.pendingEncryption,
      Messages.ear_Extract_Encryption_State_Encrypting_mttw(),
    ],
    [
      ExtractEncryptionState.unencrypted,
      siteEaRMode === ExtractEncryptionMode.DISABLED ? Messages.extract() : Messages.ear_Extract_Encryption_State_Unencrypted(),
    ],
  ]);

  // ExtractMoveToTheWebEnabled, will use new message to replace the existing message
  if (extractCreationPending) {
    return Messages.ExtractCreationPending();
  }

  if (!lastRefreshedCell) {
    if (isExtractEncryptionEnabled && hasExtracts) {
      const result = extractEncryptionState ? messages.get(extractEncryptionState) : '';
      return result || '';
    }
  }

  if (isFileBased && connectionType !== 'sqlproxy' && !hasExtracts) {
    const result = Messages.fileBased();
    return result;
  }

  return hasExtracts ? Messages.extract() : Messages.liveConnection();
}
